import '../styles/main.scss';
import './loader';
import './fonts';
import './general';
import './form';
import './lib/slick';
import './slider';
import './rent';
import './custom-select';
import './header';
import './scrollmagic';
import './video';
import './cross-line';






// WEBPACK FOOTER //
// ./scripts/main.js